export default __webpack_public_path__ + "static/jobxai-logo-d10553ec8c65914a5f4c8a5f98a9754b.png";